/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Provide the sites for your app. Each site includes site id, and its localization configuration.
// You can also provide alias for your locale. They will be used in place of your locale id when generating paths across the app
module.exports = [
    {
        id: 'stokke',
        defaultSite: true,
        isContentOnlySite: true,
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-GR',
            supportedLocales: [
                {id: 'en-AE', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-AL', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-AM', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-AU', preferredCurrency: 'EUR', dateFns: 'en-AU'},
                {id: 'en-AZ', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-BY', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-BA', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-CY', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-EG', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-GE', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-GR', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-HK', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-HU', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-IS', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-IN', preferredCurrency: 'EUR', dateFns: 'en-IN'},
                {id: 'en-IR', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-IL', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-KZ', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-MY', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-NZ', preferredCurrency: 'EUR', dateFns: 'en-NZ'},
                {id: 'en-QA', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-SA', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-RS', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-SG', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-UA', preferredCurrency: 'EUR', dateFns: 'en-UA'},
                {id: 'en-ZA', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'pt-BR', preferredCurrency: 'EUR', dateFns: 'pt-BR'},
                {id: 'es-AR', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-CL', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-CO', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-CR', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-MX', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-PA', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-PE', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'es-PR', preferredCurrency: 'EUR', dateFns: 'es'},
                {id: 'tr-TR', preferredCurrency: 'EUR', dateFns: 'tr'},
                {id: 'zh-TW', preferredCurrency: 'EUR', dateFns: 'zh-TW'},
                {id: 'zh-HK', preferredCurrency: 'EUR', dateFns: 'zh-HK'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'AUT',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'de-AT',
            supportedLocales: [
                {
                    id: 'de-AT',
                    preferredCurrency: 'EUR',
                    dateFns: 'de-AT'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'BEL',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'nl-BE',
            supportedLocales: [
                {id: 'fr-BE', preferredCurrency: 'EUR', dateFns: 'fr'},
                {id: 'nl-BE', preferredCurrency: 'EUR', dateFns: 'nl-BE'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'CHE',
        l10n: {
            supportedCurrencies: ['CHF'],
            defaultCurrency: 'CHF',
            defaultLocale: 'de-CH',
            supportedLocales: [
                {id: 'de-CH', preferredCurrency: 'CHF', dateFns: 'de'},
                {id: 'fr-CH', preferredCurrency: 'CHF', dateFns: 'fr-CH'},
                {id: 'it-CH', preferredCurrency: 'CHF', dateFns: 'it-CH'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'CHN',
        isContentOnlySite: true,
        l10n: {
            supportedCurrencies: ['CNY'],
            defaultCurrency: 'CNY',
            defaultLocale: 'zh-CN',
            supportedLocales: [
                {
                    id: 'zh-CN',
                    preferredCurrency: 'CNY',
                    dateFns: 'zh-CN'
                }
            ]
        }
    },
    {
        id: 'GBR',
        l10n: {
            supportedCurrencies: ['GBP'],
            defaultCurrency: 'GBP',
            defaultLocale: 'en-GB',
            supportedLocales: [
                {
                    id: 'en-GB',
                    preferredCurrency: 'GBP',
                    dateFns: 'en-GB'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'DEU',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'de-DE',
            supportedLocales: [
                {
                    id: 'de-DE',
                    preferredCurrency: 'EUR',
                    dateFns: 'de'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'DNK',
        l10n: {
            supportedCurrencies: ['DKK'],
            defaultCurrency: 'DKK',
            defaultLocale: 'da-DK',
            supportedLocales: [
                {
                    id: 'da-DK',
                    preferredCurrency: 'DKK',
                    dateFns: 'da'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'ESP',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'es-ES',
            supportedLocales: [
                {
                    id: 'es-ES',
                    preferredCurrency: 'EUR',
                    dateFns: 'es'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'EUR',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-PT',
            supportedLocales: [
                {id: 'en-BG', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-HR', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-CZ', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-EE', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-LV', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-LT', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-PT', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-RO', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-SK', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'en-SI', preferredCurrency: 'EUR', dateFns: 'en-US'},
                {id: 'fr-LU', preferredCurrency: 'EUR', dateFns: 'fr'},
                {id: 'de-LU', preferredCurrency: 'EUR', dateFns: 'de'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'FIN',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-FI',
            supportedLocales: [
                {
                    id: 'en-FI',
                    preferredCurrency: 'EUR',
                    dateFns: 'en-US'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'FRA',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'fr-FR',
            supportedLocales: [
                {
                    id: 'fr-FR',
                    preferredCurrency: 'EUR',
                    dateFns: 'fr'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'IRL',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-IE',
            supportedLocales: [
                {
                    id: 'en-IE',
                    preferredCurrency: 'EUR',
                    dateFns: 'en-IE'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'ITA',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'it-IT',
            supportedLocales: [
                {
                    id: 'it-IT',
                    preferredCurrency: 'EUR',
                    dateFns: 'it'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'JPN',
        l10n: {
            supportedCurrencies: ['JPY'],
            defaultCurrency: 'JPY',
            defaultLocale: 'ja-JP',
            supportedLocales: [
                {
                    id: 'ja-JP',
                    preferredCurrency: 'JPY',
                    dateFns: 'ja'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'NLD',
        l10n: {
            supportedCurrencies: ['EUR'],
            defaultCurrency: 'EUR',
            defaultLocale: 'nl-NL',
            supportedLocales: [
                {
                    id: 'nl-NL',
                    preferredCurrency: 'EUR',
                    dateFns: 'nl'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'NOR',
        l10n: {
            supportedCurrencies: ['NOK'],
            defaultCurrency: 'NOK',
            defaultLocale: 'no-NO',
            supportedLocales: [
                {
                    id: 'no-NO',
                    preferredCurrency: 'NOK',
                    dateFns: 'nb'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'POL',
        l10n: {
            supportedCurrencies: ['PLN'],
            defaultCurrency: 'PLN',
            defaultLocale: 'pl-PL',
            supportedLocales: [
                {
                    id: 'pl-PL',
                    preferredCurrency: 'PLN',
                    dateFns: 'pl'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'SWE',
        l10n: {
            supportedCurrencies: ['SEK'],
            defaultCurrency: 'SEK',
            defaultLocale: 'sv-SE',
            supportedLocales: [
                {
                    id: 'sv-SE',
                    preferredCurrency: 'SEK',
                    dateFns: 'sv'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'USA',
        l10n: {
            supportedCurrencies: ['USD'],
            defaultCurrency: 'USD',
            defaultLocale: 'en-US',
            supportedLocales: [
                {
                    id: 'en-US',
                    preferredCurrency: 'USD',
                    dateFns: 'en-US'
                }
            ]
        },
        gdpr: {
            enableCookiebot: true,
            cookiebotRegions: "{'region':'US','cbid':'7acc1db1-8589-4c22-bde1-7440af58e747'}"
        }
    },
    {
        id: 'CAN',
        l10n: {
            supportedCurrencies: ['CAD'],
            defaultCurrency: 'CAD',
            defaultLocale: 'en-CA',
            supportedLocales: [
                {id: 'en-CA', preferredCurrency: 'CAD', dateFns: 'en-CA'},
                {id: 'fr-CA', preferredCurrency: 'CAD', dateFns: 'fr-CA'}
            ]
        },
        gdpr: {
            enableCookiebot: true
        }
    },
    {
        id: 'KOR',
        l10n: {
            supportedCurrencies: ['KRW'],
            defaultCurrency: 'KRW',
            defaultLocale: 'ko-KR',
            supportedLocales: [
                {
                    id: 'ko-KR',
                    preferredCurrency: 'KRW',
                    dateFns: 'ko'
                }
            ]
        },
        gdpr: {
            enableCookiebot: false
        }
    }
]
